import { flatten } from 'lodash';

function generateClasses(values: DistanceType[]): ClassType[] {
  const classes = values.map((distance) => distance.classes || []);
  return flatten(classes);
}

export { generateClasses };
